import $ from 'jquery';
import RSVP from 'rsvp';

let searchRequest;

const LandingService = {
  fetchTours() {
    if (searchRequest && searchRequest.abort) {
      searchRequest.abort();
    }

    return new RSVP.Promise(function (resolve, reject) {
      searchRequest = $.get('/landing_tours', resolve).fail(reject);
    }).then(function (json) {
      return json;
    });
  },
};

export default LandingService;
